export default __webpack_public_path__ + "static/media/camping_1.b94bcee8.jpg";